import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/global/generic.types').Page} */
const initialState = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
};

const fetchDealersFailureReducer = () => initialState;

/**
 * @param {import('modules/global/generic.types').Page} _
 * @param {import('modules/dealers/types').GenericDealersActionPage} action
 * @returns {import('modules/global/generic.types').Page}
 */
const fetchDealersSuccessReducer = (_, { payload }) => payload.page ?? null;

export default createReducer(initialState, {
  [types.FETCH_DEALERS_FAILURE]: fetchDealersFailureReducer,
  [types.FETCH_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
});
